import { IDB_uploads } from '../IDB/IDB.deviceDB'
import type { FileId } from '../../../shared/domain/files/types.no-deps'
import { streamChunks } from '../../../app-core/lib/upload/chunk'
import { readChunk } from './fileChunk'

export async function readBlob(fileId: FileId) {
    const upload = await IDB_uploads().get(fileId)
    if (upload == null) return null

    const { fileSizeInBytes, mimeType } = upload.fileUploadData
    const chunks: ArrayBuffer[] = []

    if (fileSizeInBytes <= 0) return null

    // Read the chunks into an array
    await streamChunks(
        fileSizeInBytes,
        (chunkIndex) => readChunk(fileId, chunkIndex),
        async (_, chunk) => {
            chunks.push(chunk)
        }
    )

    // Concatenate into a blob
    return new Blob(chunks, { type: mimeType })
}
